import { Injectable, signal } from '@angular/core';
import { AdminCommonHttpService } from './admin-common-http.service';

@Injectable({ providedIn: 'root' })
export class FeedService {

  destinations = signal<any[]>([]);
  accounts = signal<any[]>([]);

  constructor(private http: AdminCommonHttpService) { }

  async loadFeedDestinations() {
    try {
      const result = await this.http.getFeedDestinations();
      this.destinations.set(result || []);
    } catch (err) {
      console.error('Failed to load feed destinations:', err);
    }
  }

  async loadTenantFeedAccounts() {
    try {
      const result = await this.http.getTenantFeedAccounts();
      this.accounts.set(result || []);
    } catch (err) {
      console.error('Failed to load tenant feed accounts:', err);
    }
  }

  async connectFeedAccount(payload: any) {
    return await this.http.connectFeedAccount(payload);
  }

  async disconnectFeedAccount(destinationCode: string) {
    return await this.http.disconnectFeedAccount(destinationCode);
  }

  async getTenantFieldMappings(destinationCode: string) {
    return await this.http.getTenantFieldMappings(destinationCode)
  }

  async updateTenantMappings(payload: any) {
    return await this.http.saveMappings(payload);
  }

  async getFieldMappingsForDestination(destinationCode: string) {
    return await this.http.getFieldMappingsForDestination(destinationCode);
  }

  async getProductById(productId: string) {
    return await this.http.getProductById(productId);
  }

  async getSourceFields(): Promise<any> {
    return await this.http.getSourceFields();
  }

}
